const SPLASH_SCREEN_KEY = 'MmAfeF?aLiDaM:!';

export function setSplashScreenBoolean(hasSeenSplashScreen) {
  localStorage.setItem(SPLASH_SCREEN_KEY, hasSeenSplashScreen);
}

export function getSplashScreenBoolean() {
  return localStorage.getItem(SPLASH_SCREEN_KEY);
}
